import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.75 16.75a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12 2a5.25 5.25 0 0 0-5.25 5.25v1.875H5.5a2.25 2.25 0 0 0-2.25 2.25v8.375A2.25 2.25 0 0 0 5.5 22h13a2.25 2.25 0 0 0 2.25-2.25v-8.375a2.25 2.25 0 0 0-2.25-2.25h-1.25V7.25C17.25 4.35 14.9 2 12 2m3.75 5.25v1.875h-7.5V7.25a3.75 3.75 0 1 1 7.5 0M5.5 10.625a.75.75 0 0 0-.75.75v8.375c0 .414.336.75.75.75h13a.75.75 0 0 0 .75-.75v-8.375a.75.75 0 0 0-.75-.75z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }